const apiUrl = process.env.REACT_APP_API_URL;

export async function EvolveUserEquipment(idUsuari: number, idItemInstance: number, type: string, targetId: number) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/item/evolve-equipment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ idUsuari, idItemInstance, type, targetId })
        });
        return response.ok;
    } catch (error) {
        console.error("Error evolving user equipment:", error);
        return false;
    }
}

export async function EvolveUserJavamon(idUsuari: number, idItemInstance: number, javamonInstance: number, evolvedJavamonId: number) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/item/evolve-javamon`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ idUsuari, idItemInstance, javamonInstance, evolvedJavamonId })
        });
        return response.ok;
    } catch (error) {
        console.error("Error evolving user javamon:", error);
        return false;
    }
}
